module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SignIn'), _vm._v(" "), (_vm.isProductSubscription && !_vm.canUserPurchaseSubscriptionProduct) ? _c('BoxNotification', {
    staticClass: "multiple-subscription",
    attrs: {
      "notificationState": 'warning'
    }
  }, [_c('p', {
    staticClass: "m-boxNotification__Message",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_c('span', {
    staticClass: "m-boxNotification__Message--Bold"
  }, [_vm._v("Heads up ")]), _vm._v("\n      - This account has an active " + _vm._s(_vm.ownedSubscriptionGroup) + " subscription.\n      Visit "), _c('span', {
    staticClass: "m-boxNotification__Message--Account"
  }, [_vm._v("My Account")]), _vm._v(" to view details\n      "), _c('a', {
    staticClass: "m-boxNotification__Message--ManagePlan",
    attrs: {
      "href": "https://account.serato.com/#/subscriptions",
      "rel": "noopener noreferrer"
    }
  }, [_c('button', {
    staticClass: "a-Button--Small a-Button--notifications a-Button--notifications--warning"
  }, [_vm._v("Manage")])])])]) : (!_vm.userCanUpgradeProduct) ? _c('BoxNotification', {
    staticClass: "multiple-subscription",
    attrs: {
      "notificationState": 'messageNotification'
    }
  }, [_c('p', {
    staticClass: "m-boxNotification__Message",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("\n      Sorry, there’s no \n      "), _c('span', {
    staticClass: "m-boxNotification__Message--Bold m-boxNotification__Message__Product"
  }, [_vm._v("Pitch ’n Time ")]), _vm._v("\n      upgrade available for this account.\n      If you wish to change your plan please follow the link below.\n      "), (_vm.changeUserUrl) ? _c('a', {
    staticClass: "m-boxNotification__Message--ChangePlan",
    attrs: {
      "href": _vm.changeUserUrl,
      "rel": "noopener noreferrer"
    }
  }, [_c('button', {
    staticClass: "a-Button--Medium a-Button--LightBlue"
  }, [_vm._v("Sign in as someone else")])]) : _vm._e(), _vm._v(" "), (_vm.changeUserUrl) ? _c('a', {
    staticClass: "m-boxNotification__Message--ChangePlan",
    attrs: {
      "href": "/pitchntime",
      "rel": "noopener noreferrer"
    }
  }, [_c('button', {
    staticClass: "a-Button--Medium a-Button--LightBlue"
  }, [_vm._v("Buy Pitch’n Time")])]) : _vm._e()])]) : _c('div', {
    staticClass: "p-payment"
  }, [_c('OrderSummary', {
    ref: "orderSummary"
  }), _vm._v(" "), _c('PaymentsDetails', {
    ref: "paymentsDetails"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4de38d84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/pages/Payment.vue
// module id = 530
// module chunks = 2